import React from "react"
import styled from 'styled-components';
import media from 'css-in-js-media'

import Instagram from '../svg/Instagram.svg';
import Facebook from '../svg/facebook.svg';
import Youtube from '../svg/youtube.svg';
import Linkedin from '../svg/linkedin.svg';
import Twitter from '../svg/twitter.svg';
import Pinterest from '../svg/pinterest.svg';

const SocialWrap = styled.a`
  padding-right: 50px;
  margin-bottom: 33px;
  display: inline-block;
  cursor: pointer;
  &:last-child {
    padding-right: 0;
  }
  ${media('<desktop')} {
    padding-right: 98px;
    &:nth-child(3) {
      padding-right: 0;
    }
  }
`;

type SocialType = {
  name?: string;
  externalLink?: string;
}

interface Props {
  socialLink: SocialType;
}

const SocialIcon = ({ name }: any) => {  
  switch (name) {
    case 'instagram':
      return <Instagram />
    case 'facebook':
      return <Facebook />
    case 'youtube':
      return <Youtube />
    case 'linkedin':
      return <Linkedin />
    case 'twitter':
      return <Twitter />
    case 'pinterest':
      return <Pinterest />    
    default:
      return null;
  }  
}

const SocialLink = ({ socialLink }: Props) => {
  return (
    <SocialWrap href={socialLink?.externalLink} target="_blank">
      <SocialIcon name={socialLink?.name} />
    </SocialWrap>
  )   
}

export default SocialLink;
